































import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import QStandardConditionalQuestion from "./QStandardConditionalQuestion.vue"
import QCandidateProfileConditionalQuestion from "./QCandidateProfileConditionalQuestion.vue"
import { mapState } from "vuex"

@Component({
  components: {
    QStandardConditionalQuestion,
    QCandidateProfileConditionalQuestion,
  },
  computed: {
    ...mapState("QuestionGroup", {
      questionGroup: "questionGroup",
    }),
  },
})
export default class QuestionGroupPreview extends Vue {
  @Prop({ default: false }) readonly startQuestion!: boolean
  questionGroup!: Model

  question: Model | null = null
  reload = 0

  @Watch("startQuestion", { immediate: true })
  watchStartQuestion(newVal, oldVal) {
    if (newVal && newVal !== oldVal) {
      this.fetchQuestion(0)
    }
  }

  get moduleName() {
    return this.questionGroup.is_for_candidate_profile
      ? "CandidateProfile"
      : "QuestionnaireAnswer"
  }

  async fetchQuestion(offset: number | null = null) {
    await this.$store
      .dispatch(this.moduleName + "/fetchNextQuestion", {
        params: {
          question_group: this.questionGroup.object_id,
          offset: offset,
        },
      })
      .then((response) => {
        this.$emit("updateSidebar", response.data.data)

        // Update the progress data in the questionnaire answer
        this.$store.commit(
          this.moduleName + "/UPDATE_PROGRESS",
          response.data.data
        )

        if (!response.data.data.question) {
          this.question = null
        } else {
          this.question = this.$store.getters["Questionnaire/mapQuestion"](
            response.data.data.question
          )
        }

        this.reload++
      })
  }

  nextQuestion(payload) {
    // Update the progress data in the questionnaire answer
    this.$store.commit(this.moduleName + "/UPDATE_PROGRESS", payload)

    this.$emit("updateSidebar", payload)

    if (
      !payload.question ||
      (this.question?.object_id === payload.question?.object_id &&
        this.question?.value.question.looped_by_value ===
          payload.question?.looped_by_value)
    ) {
      return this.$emit("complete")
    }

    if (!payload.question) {
      this.question = null
    } else {
      this.question = this.$store.getters["Questionnaire/mapQuestion"](
        payload.question
      )
    }

    this.reload++
  }
}
